// extracted by mini-css-extract-plugin
export var attention = "style-module--attention--8f9cf";
export var content = "style-module--content--1754a";
export var image = "style-module--image--9ff4b";
export var item = "style-module--item--0791a";
export var list = "style-module--list--a8af1";
export var title = "style-module--title--057d5";
export var wrapper = "style-module--wrapper--39878";